import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { AltaDeVendedoresService } from '../../services/alta-de-vendedores.service';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';
import { IndicadoresVivosService } from 'src/app/aplicaciones-modulos/indicadores-vivos/services/indicadores-vivos.service';
import { AsignacionDistribucionService } from '../../services/asignacion-y-distribucion.service';
import { ConfiguracionTiposVariablesIncentivosService } from '../../services/configuracion-tipos-variables-incentivos.service';



@Component({
  selector: 'app-asignacion-y-distribucion',
  templateUrl: './asignacion-y-distribucion.component.html',
  styleUrls: ['./asignacion-y-distribucion.component.css']
})
export class AsignacionDistribucionComponent implements OnInit {

  tituloCard: string = 'Asignación y Distribución de Pesos a Variables y Compensaciones';
  tituloForm: string = 'Lista Detalle de asignaciones';

  formulario: FormGroup;
  formularioFiltroTipoDeVendedores: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbEstadosFiltro: any[] = [
    {
      clave: '1',
      valor: 'ACTIVO'
    },
    {
      clave: '0',
      valor: 'INACTIVO'
    },
  ];

  cmbEstados: any[] = [
    {
      clave: 'ACTIVO',
      valor: 'ACTIVO'
    },
    {
      clave: 'INACTIVO',
      valor: 'INACTIVO'
    },
  ];

  cmbSiNo: any[] = [
    {
      clave: '1',
      valor: 'SI'
    },
    {
      clave: '0',
      valor: 'NO'
    },
  ];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _serviciosCRUD: AsignacionDistribucionService,
    private _tipoDeVendedor: TipoDeVendedorService,
    private _tipoDeVariables: ConfiguracionTiposVariablesIncentivosService,
  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({
      asignacionId: [null, null],
      tipoAsignacion: ['', null],
      fechaInicio: ['', []],
      fechaFin: ['', []],
      tipoVendedorId: ['', [Validators.required]],
      usuarioCarga: ['', []],
      fechaCarga: ['', []],
      estado: ['', []],
      variableId: ['', [Validators.required]],
      valorPeso: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
    });

    this.formularioFiltroTipoDeVendedores = this.fb.group({
      idTipoVendedor: ['', []],
    });

    this.formularioFiltroTipoDeVendedores.get('idTipoVendedor').valueChanges
      .subscribe((resp) => {
        // if (resp) {
          this._serviciosCRUD.getTodoPorTipoDeVendedor(resp).subscribe((res: any[]) => {
            console.log("getTodo()", res)
            this.loading = false;
            this.listaVacia = (res.length === 0) ? true : false;
            this.rowData = res;

            for (let i = 0; i < this.rowData.length; i++) {
              this.rowData[i].fechaInicioSplit = this.rowData[i].fechaInicio != null ? this.rowData[i].fechaInicio.split("T")[0] : '';
              this.rowData[i].fechaFinSplit = this.rowData[i].fechaFin != null ? this.rowData[i].fechaFin.split("T")[0] : '';
            }

            console.log("this.rowData", this.rowData)
          }, (err) => {
            this.loading = false;
            this.listaVacia = true;
            this.rowData = [];
          });
        // }
      });

    this.formulario.get('tipoVendedorId').valueChanges
      .subscribe((resp) => {
        if (resp) {
          this.loading = true;
          this._serviciosCRUD.getTodoPorTipoDeVendedor(resp).subscribe((res: any[]) => {
            console.log("getPorVendedorId()", res)
            if (resp) {
              this.formulario.controls['nombreVendedorDescripcion'].setValue(resp.nombreVendedor1);
            } else {
              this.formulario.controls['nombreVendedorDescripcion'].setValue('');
            }
          }, (err) => {
            this.loading = false;
            this.formulario.controls['nombreVendedorDescripcion'].setValue('');
          });
        }
        this.getFormValidationErrors();
      });

    this.cargarGridcomponent();
    this.getTodo();

    this.getTiposDeVendedores();
    this.getTiposDeVariables();

  }

  listTiposDeVendedores;
  getTiposDeVendedores() {
    this.loading = true;
    this._tipoDeVendedor.getTiposDeVendedoresPorEstado("1").subscribe((res: any[]) => {
      console.log("getTiposDeVendedores()", res)
      this.loading = false;
      this.listTiposDeVendedores = res;

      this.listTiposDeVendedores.unshift({
        descripcion: 'TODOS',
        idTipo: '',
      });

      this.formularioFiltroTipoDeVendedores.get("idTipoVendedor").setValue('');

    }, (err) => {
      this.loading = false;
      this.listTiposDeVendedores = [];
    });
  }

  listTiposDeVariables;
  getTiposDeVariables() {
    this.loading = true;
    this._tipoDeVariables.getTodoPorEstado("1").subscribe((res: any[]) => {
      console.log("getTiposDeVariables()", res)
      this.loading = false;
      this.listTiposDeVariables = res;
    }, (err) => {
      this.loading = false;
      this.listTiposDeVariables = [];
    });
  }

  /* FUNCIONES */
  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'idAsignacion',
        filter: true,
        sortable: true,
        resizable: true,
        // width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Tipo Vendedor',
        field: 'descripcionVendedor',
        sortable: true,
        // width: 160,
        filter: true,
        resizable: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Variables',
        field: 'descripcionVariable',
        sortable: true,
        // width: 160,
        filter: true,
        resizable: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Inicio',
        field: 'fechaInicioSplit',
        sortable: true,
        // width: 160,
        filter: true,
        resizable: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Fin',
        field: 'fechaFinSplit',
        sortable: true,
        // width: 160,
        filter: true,
        resizable: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Peso %',
        field: 'peso',
        sortable: true,
        // width: 160,
        filter: true,
        resizable: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Valor Mínimo',
        field: 'minimo',
        sortable: true,
        // width: 160,
        filter: true,
        resizable: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Valor Máximo',
        field: 'maximo',
        sortable: true,
        // width: 160,
        filter: true,
        resizable: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 150,
      //   cellRendererParams: {
      //     onClick: this.editar.bind(this),
      //     label: this.DAT_BTNS.editar,
      //     colorBoton: this.DAT_BTNCSS.warning
      //   }
      // },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 150,
      //   cellRendererParams: {
      //     onClick: this.eliminar.bind(this),
      //     label: this.DAT_BTNS.eliminar,
      //     colorBoton: this.DAT_BTNCSS.danger
      //   }
      // },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    //params.api.sizeColumnsToFit();

  }

  nuevo() {
    this.formulario.reset();
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar';
  }

  editar({ rowData }) {
    console.log("editar", rowData)
    rowData.sueldoVariable = "";
    this.formulario.reset();
    this.formulario.setValue(rowData);
    document.getElementById('buttonAbrirModal').click();
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Asignación y Distribución de Pesos a Variables Compensaciones';
    this.tituloForm = 'Lista De Asignación y Distribución de Pesos a Variables Compensaciones';
  }

  /** SERVICIOS */
  getTodo() {
    this.listaVacia = true;
    this.loading = true;

    this._serviciosCRUD.getTodo().subscribe((res: any[]) => {
      console.log("getTodo()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;

      for (let i = 0; i < this.rowData.length; i++) {
        this.rowData[i].fechaInicioSplit = this.rowData[i].fechaInicio != null ? this.rowData[i].fechaInicio.split("T")[0] : '';
        this.rowData[i].fechaFinSplit = this.rowData[i].fechaFin != null ? this.rowData[i].fechaFin.split("T")[0] : '';
      }

      console.log("this.rowData", this.rowData)
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  eliminar({ rowData }) {
    console.log("eliminar", rowData)
    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._serviciosCRUD.delete(rowData),
      })
      .then((res: any) => {
        this.getTodo();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

  guardar() {

    let datos = this.formulario.getRawValue();
    datos.fechaInicio = datos.fechaInicio + 'T00:00:00';
    datos.fechaFin = datos.fechaFin + 'T00:00:00';
    console.log("datos", datos);

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._serviciosCRUD.save(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getTodo();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  actualizar() {
    console.log("actualizar")

    console.log(this.formulario.getRawValue())
    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._serviciosCRUD.update(this.formulario.getRawValue()),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getTodo();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  descargarExcel() {
    let data: any = [];
    let cabecera: any[] = [['ID', 'Tipo Vendedor', 'Variables', 'Fecha Inicio', 'Fecha Fin', 'Mínimo', 'Máximo', 'Peso %']];
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    console.log("clonData", clonData)
    clonData.forEach((e) => {
      data.push(
        {
          idAsignacion: (e.idAsignacion === undefined) ? '' : e.idAsignacion,
          descripcionVendedor: (e.descripcionVendedor === undefined) ? '' : e.descripcionVendedor,
          tipoVariable: (e.descripcionVariable === undefined) ? '' : e.descripcionVariable,
          fechaInicioSplit: (e.fechaInicioSplit === undefined) ? '' : e.fechaInicioSplit,
          fechaFinSplit: (e.fechaFinSplit === undefined) ? '' : e.fechaFinSplit,
          // peso: (e.peso === undefined) ? '' : e.peso,
          minimo: (e.minimo === undefined) ? '' : e.minimo,
          maximo: (e.maximo === undefined) ? '' : e.maximo,
          peso: (e.peso === undefined) ? '' : e.peso,
        }
      );
    });
    let name: string = "Asignación_y_Distribución.csv";
    this._utils.exportCSV(cabecera, data, name);
    // this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

}
